import { render, staticRenderFns } from "./GroupSuperAdminOptions.vue?vue&type=template&id=58cea019&scoped=true&"
import script from "./GroupSuperAdminOptions.vue?vue&type=script&lang=js&"
export * from "./GroupSuperAdminOptions.vue?vue&type=script&lang=js&"
import style0 from "./GroupSuperAdminOptions.vue?vue&type=style&index=0&id=58cea019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cea019",
  null
  
)

export default component.exports